import { Routes } from '@angular/router';
import { FrontendAdminComponent } from './components/frontend-admin/frontend-admin.component';

export const FRONTEND_ROUTES: Routes = [{
	path: 'Frontend', component: FrontendAdminComponent
}];
